import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Poetica',
        projectDesc: 'Web-based application that generates poems based on user prompts and analyzes the emotions within the generated poem using a pre-trained NLP model.',
        tags: ['AWS EC2','GEN AI', 'Flask', 'Python',],
        code: 'https://github.com/Sudhanshu-Patil/Poetica',
        demo: 'http://13.202.146.142/',
        image: one
    },
    
    {
        id: 2,
        projectName: 'Django Market',
        projectDesc: 'Django-market is a fully open-source E-commerce platform built using Django Web Framework, designed with Bootstrap4 with modules developed upon the inbuilt django admin.',
        tags: ['Django', 'Bootstrap', 'SQLite'],
        code: 'https://github.com/Sudhanshu-Patil/Django-market',
        demo: 'https://github.com/Sudhanshu-Patil/Django-market',
        image: three
    },
    {
        id: 3,
        projectName: 'SnakeAI',
        projectDesc: 'AI driven snake game using Reinforcement Learning and Deep Q Learning',
        tags: ['Reinforcement Learning', 'Python', 'ML'],
        code: 'https://github.com/Sudhanshu-Patil/Snakeai',
        demo: 'https://github.com/Sudhanshu-Patil/Snakeai',
        image: two
    },
    {
        id: 4,
        projectName: 'StockPred',
        projectDesc: 'Gathers machine learning and deep learning models for Stock forecasting including trading bots and simulations.',
        tags: ['Python', 'ML Algos', 'Stock Market'],
        code: 'https://github.com/Sudhanshu-Patil/StockPred',
        demo: 'https://sudhanshu-patil.github.io/StockPred/stock-forecasting-js/index.html',
        image: one
    },
    {
        id: 5,
        projectName: 'Air Traffic Control',
        projectDesc: 'Using different OS concepts to create an Air Traffic Control System.',
        tags: ['Linux', 'C', 'OS Concepts'],
        code: 'https://github.com/Sudhanshu-Patil/ATC-System',
        demo: 'https://github.com/Sudhanshu-Patil/ATC-System',
        image: three
    },
    {
        id: 6,
        projectName: 'Hotel Management System',
        projectDesc: 'Using different OS concepts such as Linux commands, process creation, inter-process communication, wait(), sleep(), etc. to create a hotel management system application.',
        tags: ['Linux', 'C', 'OS Concepts'],
        code: 'https://github.com/Sudhanshu-Patil/Hotel-Management-System',
        demo: 'https://github.com/Sudhanshu-Patil/Hotel-Management-System',
        image: two
    },
    {
        id: 7,
        projectName: 'SmartOrbit',
        projectDesc: 'An Automatic Collision Avoidance System for near earth satellites.',
        tags: ['Python', 'Numpy', 'Pandas'],
        code: 'https://github.com/Sudhanshu-Patil/SmartOrbit',
        demo: 'https://github.com/Sudhanshu-Patil/SmartOrbit',
        image: one
    },
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/